/**
 * Notification Slice
 *
 * Global notification management. Pages dispatch addNotification()
 * and the App layout renders them via Cloudscape Flashbar.
 *
 * Usage:
 *   dispatch(addNotification({ type: 'error', header: 'Failed to load', content: 'Network error' }));
 *   dispatch(dismissNotification(id));
 *   dispatch(clearNotifications());
 */
import { createSlice, PayloadAction, nanoid } from '@reduxjs/toolkit';
import { notificationInitialState, AppNotification, NotificationType } from './notificationState';

const notificationSlice = createSlice({
  name: 'notifications',
  initialState: notificationInitialState,
  reducers: {
    addNotification: {
      reducer: (state, action: PayloadAction<AppNotification>) => {
        state.items.push(action.payload);
      },
      prepare: (payload: { type: NotificationType; header: string; content?: string; dismissible?: boolean }) => ({
        payload: { id: nanoid(), dismissible: true, ...payload },
      }),
    },
    dismissNotification: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(n => n.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.items = [];
    },
  },
});

export const { addNotification, dismissNotification, clearNotifications } = notificationSlice.actions;
export default notificationSlice.reducer;
